// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowSuggestion-cls1__ae3f8106e68266a4a91e","cls2":"BulkFollowSuggestion-cls2___544010c6dcc48ddf370 BulkFollowSuggestion-cls1__ae3f8106e68266a4a91e"};